var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Colors } from '@pacem/pacem-foundation';
import { Utils } from '../../utils';
import { PropertyConverters } from '../../converters';
import { Watch, CustomElement } from '../../decorators';
import { P } from '../../prefix';
import { TweenAnimationElement } from './animation';
//namespace Pacem.Components {
const DEFAULT_FROM = { h: 0, l: 0, s: 0.5, a: 1 };
const DEFAULT_TO = { h: 0, l: 1, s: 0.5, a: 1 };
let PacemColorAnimationElement = class PacemColorAnimationElement extends TweenAnimationElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'from':
                    this._precomputeFrom(val);
                    break;
                case 'to':
                    this._precomputeTo(val);
                    break;
            }
        }
    }
    #from = DEFAULT_FROM;
    #to = DEFAULT_TO;
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._precomputeColors();
    }
    _precomputeColors() {
        this._precomputeFrom();
        this._precomputeTo();
    }
    _precomputeFrom(v = this.from) {
        this.#from = this._precomputeColor(v) ?? DEFAULT_FROM;
    }
    _precomputeTo(v = this.to) {
        this.#to = this._precomputeColor(v) ?? DEFAULT_FROM;
    }
    _precomputeColor(clr) {
        if (!Utils.isNullOrEmpty(clr)) {
            try {
                return this._parseColor(clr);
            }
            catch {
                return null;
            }
        }
    }
    _parseColor(clr) {
        return Colors.hsl(Colors.parse(clr));
    }
    tweenInterpolationCallback(time, progress) {
        const from = this.#from, to = this.#to;
        const hsla = {
            h: (to.h - from.h) * progress + from.h,
            s: (to.s - from.s) * progress + from.s,
            l: (to.l - from.l) * progress + from.l,
            a: (to.a - from.a) * progress + from.a
        };
        return Colors.stringify(hsla);
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemColorAnimationElement.prototype, "from", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemColorAnimationElement.prototype, "to", void 0);
PacemColorAnimationElement = __decorate([
    CustomElement({ tagName: P + '-color-animation' })
], PacemColorAnimationElement);
export { PacemColorAnimationElement };
